export default "__VITE_ASSET__99ae9788__"